//Generated File 
export default class BarCodeConstants{
	static readonly ENTITY_TYPE = `entitytype`;
	static readonly NAMA_PROTOCOL_PREFIX = `nama://`;
	static readonly contextsSeparator = `_nctx_`;
	static readonly entriesSepaarator = `_ntr_`;
	static readonly keyValueSepaarator = `_nk_`;
	static readonly listSeperator = `_nlst_`;
}
